import CategoryForm from '../../components/Forms/CategoryForm';
import { invalidUrlError, validateUrl } from '../../utils/functions';

const UserForm = ({ functionality }) => {
  const fields = [
    { name: 'display_name', label: 'Name', type: 'text', required: true },
    { name: 'title', label: 'Title/Position', type: 'text', required: true },
    { name: 'expertise', label: 'Expertise/Fields of Interest', type: 'text', required: true },
    { name: 'affiliations', label: 'Organization/Affiliation', type: 'text', required: true },
    {
      name: 'organization_url',
      label: 'Organization URL',
      type: 'text',
      placeholder: 'https://google.com/',
      pattern: validateUrl,
      title: invalidUrlError,
      required: true,
    },
    { name: 'department', label: 'Department', type: 'text' },
    {
      name: 'homepage',
      label: 'Personal Website',
      type: 'text',
      placeholder: 'https://profiles.stanford.edu/jackson',
      pattern: validateUrl,
      title: invalidUrlError,
    },
    {
      name: 'LinkedIn',
      label: 'LinkedIn',
      type: 'text',
      placeholder: 'https://www.linkedin.com/in/rob-jackson/',
      pattern: validateUrl,
      title: invalidUrlError,
    },
    {
      name: 'ResearchGate',
      label: 'ResearchGate',
      type: 'text',
      placeholder: 'https://www.researchgate.net/profile/Robert-Jackson-14',
      pattern: validateUrl,
      title: invalidUrlError,
    },
    {
      name: 'GoogleScholar',
      label: 'Google Scholar',
      type: 'text',
      placeholder: 'https://scholar.google.com/citations?user=G3NBUzwAAAAJ&hl=en',
      pattern: validateUrl,
      title: invalidUrlError,
    },
    {
      name: 'ORCID',
      label: 'ORCID',
      type: 'text',
      placeholder: 'https://orcid.org/0000-0001-8846-7147',
      pattern: validateUrl,
      title: invalidUrlError,
    },
    {
      name: 'BlueSky',
      label: 'BlueSky',
      type: 'text',
      placeholder: 'https://bsky.app/profile/mcuban.bsky.social',
      pattern: validateUrl,
      title: invalidUrlError,
    },
    { name: 'about', label: 'About', type: 'text', text_area: true },
    {
      name: 'education',
      label: 'Educational Background',
      type: 'text',
      text_area: true,
      placeholder: 'Highest degree, field of study, graduating institution',
    },
    {
      name: 'professional_experience',
      label: 'Professional Background',
      type: 'text',
      text_area: true,
    },
    {
      name: 'resume',
      label: 'CV/Resume',
      type: 'text',
      placeholder: 'https://cap.stanford.edu/profiles/viewCV?facultyId=48949&name=Rob_Jackson',
      pattern: validateUrl,
      title: invalidUrlError,
      required: true,
    },
    { name: 'image_url', label: 'Image', type: 'image' },
  ];

  return (
    <CategoryForm
      category={'user'}
      fields={fields}
      functionality={functionality}
      tab="Vertical Members"
    />
  );
};
export default UserForm;
